import { loanInformationHeader } from "../utils/content";

let initialState = {
  header: true,
  headerTitle: loanInformationHeader.header,
  headerContent: loanInformationHeader.description,
  processComplete: false,
  paymentType: "debit",
  editMode: false,
  bgColor: "#fff",
  showLogoAndFooter: true,
};

export function appStatus(state = initialState, action) {
  switch (action.type) {
    case "PAUSE_APP":
      return { ...state, paused: true };
    case "RESUME_APP":
      return { ...state, paused: false };
    case "ERROR_PAGE":
      return { ...state, errorPage: true };
    case "SHOW_HEADER":
      return { ...state, header: true };
    case "HIDE_HEADER":
      return { ...state, header: false };
    // The following two are used to hide the logo display on the top and
    // the footer display on the bottom for instances where we are in an
    // iframe in mobile or online banking (DI)
    case "SHOW_LOGO_AND_FOOTER":
      return { ...state, showLogoAndFooter: true, };
    case "HIDE_LOGO_AND_FOOTER":
      return { ...state, showLogoAndFooter: false, };
      case "CHANGE_BG_COLOR":
        return { ...state, bgColor: action.bgColor };
    case "MODIFY_HEADER":
      return {
        ...state,
        headerTitle: action.headerTitle,
        headerContent: action.headerContent
      };
    case "CHANGE_PAYMENT_TYPE":
      return {
        ...state,
        paymentType: action.paymentType
      };
    case "TOGGLE_EDIT_MODE":
      return {
        ...state,
        editMode: !state.editMode
      };
    case "PROCESS_COMPLETE":
      return { ...state, processComplete: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appStatus.js